<!-- src/components/Applications/AfsalSereign/Steps/Summary.vue -->
<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useVuelidate } from '@vuelidate/core'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

// Adjust these imports if your file structure differs
import Umsaekjandi from '@/components/Applications/Shared/Umsaekjandi.vue'
import Step2 from './Step2.vue'
import Step3 from './Step3.vue'
import Step4 from './Step4.vue'
import Step5 from './Step5.vue'

const { t } = useI18n()
const { umsokn } = useUmsokn()

const expanded = ref([0]) 

const props = defineProps<{
  disable?: boolean
}>()

// No required inputs on summary; still expose validate() for wrapper
const rules = {}
const v$ = useVuelidate(rules, {})

async function validate(): Promise<boolean> {
  await v$.value.$validate()
  return !v$.value.$error
}

defineExpose({ validate })
</script>

<template>
  <div v-if="umsokn">
    <v-col>
      <v-row>
        <v-col>
          <h2 class="forms__header">
            {{ t('umsokn_samantekt_header') }}
          </h2>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <p>{{ t('umsokn_samantekt_header2') }}</p>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-expansion-panels v-model="expanded">
            <v-expansion-panel>
              <v-expansion-panel-title>
                {{ t('umsokn_samantekt_upplysingar') }}
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <div>
                  <Umsaekjandi :umsokn="umsokn" :disable="true" />
                </div>
                <div class="m-t-100">
                  <Step2 :umsokn="umsokn" :disable="true" />
                </div>
                <div class="m-t-100">
                  <Step3 :umsokn="umsokn" :disable="true" />
                </div>
                <div class="m-t-100">
                  <Step4 :umsokn="umsokn" :disable="true" />
                </div>
                <div class="m-t-100">
                  <Step5 :umsokn="umsokn" :disable="true" />
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<style scoped lang="scss">
.m-b-40 { margin-bottom: 40px; }
.m-t-100 { margin-top: 100px; }

.forms__header {
  color: #194458;
  font-weight: 900;
  font-size: 28px;
  line-height: 1.25;
  margin: 0 0 12px;
}
</style>
